import { publicUrl } from "../utils/publicUrl.js";

export const ABILITY_GLB_URLS = {
  multiveil_drone: publicUrl("glb/ability/multiveil_drone.glb"),
  fulfillment_swarmlet: publicUrl("glb/ability/fulfillment_swarmlet.glb"),
  rage_ram_shockwave: publicUrl("glb/ability/rage_ram_shockwave.glb"),
  gray_matter_charge_core: publicUrl("glb/ability/gray_matter_charge_core.glb"),
  chroma_phase_shell: publicUrl("glb/ability/chroma_phase_shell.glb"),
};

export function getAbilityGlbUrl(key) {
  const k = String(key || "").toLowerCase();
  return ABILITY_GLB_URLS[k] || null;
}

